import { useEffect } from 'react';

export const AnimationFileLoader = () => {
  useEffect(() => {
    const script = document.createElement("script");
    script.async = true;
    script.src = "/js/main.js"; // Replace with your script's path
    document.body.appendChild(script);

    var $bgImg = document.querySelectorAll("[data-bg-img]");

    $bgImg.forEach(function (element) {
      var bgImageUrl = element.getAttribute("data-bg-img");
      element.style.backgroundImage = 'url("' + bgImageUrl + '")';
      element.removeAttribute("data-bg-img");
      element.classList.add("bg-img");
    });


    return () => {
      document.body.removeChild(script);
    };
  }, []);
}